import React from 'react';
import { useTheme } from '@ublend-npm/aulaui-core';
import GlobalStyles from '@mui/material/GlobalStyles';
import { alpha } from '@mui/material/styles';

const TouchButtonStyles = () => {
  const { palette } = useTheme();

  return (
    <GlobalStyles
      styles={{
        '@media (hover: none)': {
          '.MuiButton-root.MuiButton-containedPrimary:hover': {
            backgroundColor: palette.primary.main,
            '&.Mui-disabled': {
              backgroundColor: palette.action.disabledBackground,
            },
          },
          '.MuiButton-root.MuiButton-outlinedPrimary:hover': {
            backgroundColor: 'transparent',
            borderColor: alpha(palette.primary.main, 0.5),
            '&.Mui-disabled': {
              borderColor: palette.action.disabledBackground,
            },
          },
        },
      }}
    />
  );
};

export default TouchButtonStyles;
